module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-90deg-left-b9c9a50b.svg";